import React, { FC, useEffect } from 'react';
import {
  DialogContent,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Paper,
  Box,
  FormControlLabel,
  Checkbox,
  Divider,
} from '@material-ui/core';
import { GalleryImage, Devices } from '../../../api/infomodul/models';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Autocomplete } from '@material-ui/lab';

type Props = {
  galleryData: GalleryImage[];
  deviceData: Devices[];
  StartDate: React.Dispatch<React.SetStateAction<any>>;
  EndDate: React.Dispatch<React.SetStateAction<any>>;
  selectedImageId: React.Dispatch<React.SetStateAction<number | undefined>>;
  imgName: React.Dispatch<React.SetStateAction<string | undefined>>;
  devicesForEvent: React.Dispatch<React.SetStateAction<string[] | undefined>>;
};

const CreateEvent: FC<Props> = ({
  galleryData,
  deviceData,
  StartDate,
  EndDate,
  selectedImageId,
  imgName,
  devicesForEvent,
}) => {
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(new Date());
  const [selectedDevices, setSelectedDevices] = React.useState<Devices[]>(
    []
  );
  const [selectAll, setSelectAll] = React.useState<boolean>(false);

  useEffect(() => {
    const selectedDevicesHashes: string[] | undefined = [];
    for (let i = 0; i < selectedDevices.length; i++) {
      selectedDevicesHashes.push(selectedDevices[i].clientHash);
    }
    devicesForEvent(selectedDevicesHashes);
  }, [selectedDevices]);

  const handleChangeImg = (event: React.ChangeEvent<{ value: any }>) => {
    galleryData.filter((obj) => {
      selectedImageId(event.target.value);

      return obj.imgDescription === (event.target.value as string);
    });

    var found = galleryData.find((obj) => {
      return obj.id === event.target.value;
    });
    if (found != null) {
      imgName(found.imgName);
    }
  };

  const handleDeviceChange = (newSelection: Devices[] | null) => {
    if (newSelection) {
      setSelectedDevices(newSelection);
    } else {
      setSelectedDevices([]);
    }
  };

  const handleChangeStartDate = (date: Date | null) => {
    setStartDate(date);
    var dDate = new Date(`${date}`);
    //Laver om til dansk tid
    dDate.setHours(date!.getHours() + 2);
    StartDate(dDate.toISOString());
  };

  const handleChangeEndDate = (date: Date | null) => {
    setEndDate(date);
    var dDate = new Date(`${date}`);
    //Laver om til dansk tid
    dDate?.setHours(date!.getHours() + 2);
    EndDate(dDate?.toISOString());
  };

  const handleToggleSelectAll = () => {
    setSelectAll((prev) => {
      if (!prev) {
        setSelectedDevices([...deviceData]);
      } else {
        setSelectedDevices([]);
      }
      return !prev;
    });
  };

  function TypeInfo(type: string) {
    switch (type) {
      case 'udeafdrift':
        return 'Type: Ude af drift';
      case 'pauseskaerm':
        return 'Type: Pauseskærm';
      case 'reklame':
        return 'Type: Reklame';
    }
  }

  return (
    <DialogContent>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          autoOk
          format="dd/MM/yyyy"
          label="Start dato"
          value={startDate}
          onChange={(newDate) => handleChangeStartDate(newDate)}
          disablePast
        />
        <DatePicker
          autoOk
          format="dd/MM/yyyy"
          label="Slut dato"
          value={endDate}
          onChange={(newDate) => handleChangeEndDate(newDate)}
          disablePast
          minDate={startDate}
          style={{ paddingBottom: 10 + 'px' }}
        />
      </MuiPickersUtilsProvider>
      <InputLabel
        id="select-location-label"
        style={{ paddingBottom: 10 + 'px', paddingTop: 10 + 'px' }}
      >
        Vælg billede fra galleri
      </InputLabel>
      <Select
        labelId="select-location-label"
        id="select-location"
        onChange={handleChangeImg || ''}
        defaultValue=""
        label="location"
      >
        {galleryData.map((value, i) => {
          return (
            <MenuItem value={value.id} key={i}>
              {' '}
              {value.imgDescription}
              {' - '}
              {TypeInfo(value.type)}
            </MenuItem>
          );
        })}
      </Select>
      <InputLabel
        id="select-location-label"
        style={{ paddingBottom: 10 + 'px', paddingTop: 10 + 'px' }}
      >
      </InputLabel>
      <Autocomplete
        multiple
        renderInput={(params) => (
          <TextField
            {...params}
            label={'Vælg automater'}
            variant="outlined"
            fullWidth
          />
        )}
        options={deviceData}
        getOptionLabel={(option) => option.deviceName}
        disableCloseOnSelect
        filterSelectedOptions
        limitTags={3}
        onChange={(event, newSelection) => {
          handleDeviceChange(newSelection);
        }}
        value={selectedDevices}
        PaperComponent={(paperProps) => {
          const { children, ...restPaperProps } = paperProps;
          return (
            <Paper {...restPaperProps}>
              <Box
                onMouseDown={(e) => e.preventDefault()} // prevent blur
                pl={1.5}
                py={0.5}
              >
                <FormControlLabel
                  onClick={(e) => {
                    handleToggleSelectAll();
                  }}
                  label="Vælg alle"
                  control={
                    <Checkbox id="select-all-checkbox" checked={selectAll} />
                  }
                />
              </Box>
              <Divider />
              {children}
            </Paper>
          );
        }}
      />
    </DialogContent>
  );
};

export default CreateEvent;
